import {
  yesNoSchema,
  yesNoUI,
  titleUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-legal-status-title']),
    validMarriage: yesNoUI({
      title: content['household-legal-status-valid'],
    }),
    marriageValidityExplanation: textUI({
      title: content['household-legal-status-valid-explanation'],
      required: formData => formData.validMarriage === true,
      errorMessages: {
        required: content['household-legal-status-valid-explanation-error'],
      },
      maxLength: 256,
      expandUnder: 'validMarriage',
      expandUnderCondition: true,
    }),
  },
  schema: {
    type: 'object',
    required: ['validMarriage'],
    properties: {
      validMarriage: yesNoSchema,
      marriageValidityExplanation: customTextSchema,
    },
  },
};
